(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viv-global"]) return;
  try {
    
  (function () {
    if (window.vivCartReady) return;
    window.vivCartReady = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('form[data-viv-add]');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('[type=submit]');
      var error = form.querySelector('.viv-add__error');
      var label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (error) error.textContent = '';

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      try {
        var response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: body
        });
        var data = await response.json();
        if (data.status) {
          if (error) error.textContent = data.description || data.message || 'Non è stato possibile aggiungere il prodotto.';
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          ['cart:refresh', 'cart:build', 'cart:updated'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'viv-add' } }));
          });
          /* PUB_SUB_EVENTS è una const di constants.js: non esiste su window */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'viv-add' });
          }
          if (button) {
            button.textContent = 'Aggiunto ✓';
            setTimeout(function () { button.textContent = label; }, 2200);
          }
        }
      } catch (e) {
        form.removeAttribute('data-viv-add');
        form.submit();
      } finally {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }
    });

    function initStickyBar() {
      var bar = document.getElementById('viv-stickybar');
      var main = document.querySelector('[id^="MainProduct-"] .product-form__submit');
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      var btn = bar.querySelector('.viv-stickybar__btn');
      /* Si osserva il blocco dei bottoni: il pulsante "Aggiungi" viene nascosto quando la variante è esaurita */
      var box = document.querySelector('[id^="MainProduct-"] .product-form__buttons') || main;
      function bisButton() {
        var bis = document.querySelector('[id^="MainProduct-"] .vv-bis-button');
        return bis && !bis.hidden ? bis : null;
      }
      var priceEl = bar.querySelector('.viv-stickybar__price');
      function currentSubmit() {
        return document.querySelector('[id^="MainProduct-"] .product-form__submit') || main;
      }
      /* Etichetta coerente con la variante scelta (fix 07/10): avviso Omnisend se presente,
         "Esaurito" se l'acquisto è bloccato, altrimenti "Aggiungi al carrello" */
      function updateLabel() {
        var submit = currentSubmit();
        if (bisButton()) {
          btn.textContent = 'Avvisami quando torna';
        } else if (submit && submit.disabled) {
          btn.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Esaurito';
        } else {
          btn.textContent = 'Aggiungi al carrello';
        }
      }
      /* Prezzo della barra allineato alla variante selezionata */
      function syncPrice() {
        var box = document.querySelector('[id^="MainProduct-"] [id^="price-"] .price');
        if (!box || !priceEl) return;
        var el = box.classList.contains('price--on-sale')
          ? box.querySelector('.price__sale .price-item--last')
          : box.querySelector('.price__regular .price-item--regular');
        var text = el ? el.textContent.trim() : '';
        if (text) priceEl.textContent = text;
      }
      /* Aggiornamento al cambio variante; pubsub.js è in defer, quindi si riprova finché è pronto */
      var hooked = false;
      function hookVariantChange() {
        if (hooked || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        hooked = true;
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          requestAnimationFrame(function () { updateLabel(); syncPrice(); });
        });
      }
      hookVariantChange();
      document.addEventListener('DOMContentLoaded', hookVariantChange);
      window.addEventListener('load', hookVariantChange);
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        if (hidden) updateLabel();
        bar.classList.toggle('is-visible', hidden);
        document.documentElement.classList.toggle('viv-bar-on', hidden);
        bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        btn.tabIndex = hidden ? 0 : -1;
      }).observe(box);
      btn.addEventListener('click', function () {
        var bis = bisButton();
        if (bis) { bis.click(); return; }
        var current = document.querySelector('[id^="MainProduct-"] .product-form__submit') || main;
        if (current.disabled) { current.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        current.click();
      });
    }

    /* Lista d'attesa: la porta sotto il blocco d'acquisto; per i prodotti in arrivo nasconde il pulsante */
    function initWaitlist() {
      var wait = document.getElementById('viv-wait');
      if (!wait) return;
      var info = document.querySelector('[id^="MainProduct-"] .product__info-container');
      if (!info) return;
      var anchor = info.querySelector('product-form, .product-form') || info.querySelector('[id^="price-"]');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(wait, anchor.nextSibling);
      } else {
        info.appendChild(wait);
      }
      wait.classList.add('is-placed');
      var waitBtn = wait.querySelector('[data-omnisend-form-id]');
      if (waitBtn) {
        waitBtn.addEventListener('click', function () {
          window.omnisend = window.omnisend || [];
          window.omnisend.push(['openForm', waitBtn.getAttribute('data-omnisend-form-id')]);
        });
      }
      if (wait.dataset.coming === 'true') {
        info.querySelectorAll('product-form, .product-form, .product-form__quantity, .price-per-item__container').forEach(function (el) { el.classList.add('viv-coming-hide'); });
      }
    }

    function initAll() { initStickyBar(); initWaitlist(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viv-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCover(root) {
      if (root.dataset.vivReady) return;
      root.dataset.vivReady = '1';
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          root.classList.toggle('is-paused', !entries[0].isIntersecting);
        }).observe(root);
      }
      root.addEventListener('click', function (e) {
        var m = e.target.closest('.viv-art__m');
        if (!m) return;
        m.classList.remove('is-jump');
        void m.getBoundingClientRect();
        m.classList.add('is-jump');
        setTimeout(function () { m.classList.remove('is-jump'); }, 650);
      });
    }
    function initAll() { document.querySelectorAll('[data-viv-cover]').forEach(initCover); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viv-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var state = {};
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
      var history = ['1'];
      var lead = root.querySelector('[data-lead]');

      function show(id) {
        steps.forEach(function (s) { s.hidden = s.dataset.step !== id; });
        if (lead) lead.hidden = id !== 'result';
        var target = root.querySelector('[data-step="' + id + '"]');
        var focusEl = target && target.querySelector('.viv-quiz__opt, .viv-quiz__match:not([hidden]) .viv-quiz__name');
        if (focusEl) focusEl.focus({ preventScroll: true });
      }

      function showResult() {
        root.querySelectorAll('[data-result]').forEach(function (r) { r.hidden = true; });
        var match = root.querySelector('[data-result="' + state.need + '-' + state.format + '"]');
        if (match) match.hidden = false;
        var tip = root.querySelector('[data-tip]');
        if (tip) tip.hidden = state.routine !== 'base';
        var tags = root.querySelector('[data-lead-tags]');
        if (tags) tags.value = ['newsletter', 'test-che-bocca-sei', 'test-' + state.need, 'test-formato-' + state.format, 'test-routine-' + state.routine].join(',');
        show('result');
      }

      function addAll(btn) {
        var ids = btn.dataset.addAll.split(',');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var label = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Aggiungo al carrello…';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = root + 'cart';
        }).catch(function () {
          btn.disabled = false;
          btn.innerHTML = label;
          alert('Non sono riuscita ad aggiungere i prodotti. Riprova tra un attimo.');
        });
      }

      if (lead && lead.querySelector('[data-lead-ok]')) {
        steps.forEach(function (s) { s.hidden = true; });
        lead.hidden = false;
      }

      root.addEventListener('click', function (e) {
        var all = e.target.closest('[data-add-all]');
        if (all) { addAll(all); return; }
        var opt = e.target.closest('.viv-quiz__opt');
        if (opt) {
          state[opt.dataset.key] = opt.dataset.value;
          var current = opt.closest('[data-step]').dataset.step;
          var next = current === '1' ? '2' : current === '2' ? '3' : 'result';
          history.push(next);
          if (next === 'result') showResult(); else show(next);
          return;
        }
        if (e.target.closest('[data-back]')) {
          history.pop();
          show(history[history.length - 1] || '1');
          return;
        }
        if (e.target.closest('[data-restart]')) {
          state = {};
          history = ['1'];
          show('1');
        }
      });
    }

    function initAll() { document.querySelectorAll('[data-viv-quiz]').forEach(initQuiz); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
